const translations = {
    requiredError: 'Discount type is required'
};

export default translations;
